if( window.JSON && !(navigator && navigator.platform && navigator.platform == 'PlayStation 3') ){
	window.JSON.encode = function(v){
		return JSON.stringify(v);
	};
	window.JSON.decode = function(s){
		// parse nelietojam, jo dažus JSON nevar atserializēt
		try{
			return !( /[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test( s.replace(/"(\\.|[^"\\])*"/g, '')) ) && eval( '(' + s + ')' );
		}
		catch(e){
			return false;
		}
	};
	window._DJSON = window.JSON;
} else {
	var JSON = window._DJSON = {

		decode:function(s){
			try{
				return !( /[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test( s.replace(/"(\\.|[^"\\])*"/g, '')) ) && eval( '(' + s + ')' );
			}
			catch(e){
				return false;
			}
		},

		parse:function(s){
			return this.decode(s);
		},

		encode:function(v){
			return this[ typeof v ](v);
		},

		stringify:function(v){
			return this.encode(v);
		},

		// + types +
		'boolean':function(x){
			return String(x);
		},

		'null':function(x){
			return "null";
		},

		'undefined':function(x){
			return "null";
		},

		number:function(x){
			return isFinite(x) ? String(x) : 'null';
		},

		string: function (x) {
			if (/["\\\x00-\x1f]/.test(x)) {
				var $JSON = this;
				x = x.replace(/([\x00-\x1f\\"])/g, function(a, b) {
					var c = $JSON.m[b];
					if (c) {
						return c;
					}
					c = b.charCodeAt();
					return '\\u00' +
						Math.floor(c / 16).toString(16) +
						(c % 16).toString(16);
				});
			}
			return '"' + x + '"';
		},

		array: function (x) {
			var a = ['['], b, i, l = x.length, v;
			for (i = 0; i < l; i += 1) {
				v = x[i];
				if( this[typeof v] ){
					v = this[typeof v]( v );
					if (typeof v == 'string') {
						if (b) {
							a[a.length] = ',';
						}
						a[a.length] = v;
						b = true;
					}
				}
			}
			a[a.length] = ']';
			return a.join('');
		},

		object: function (x) {
			if (x) {
				if (x instanceof Array) {
					return this.array(x);
				}
				var a = ['{'], b, i, v;
				for (i in x) {
					v = x[i];
					if( this[typeof v] ) {
						v = this[typeof v](v);
						if (typeof v == 'string') {
							if (b) {
								a[a.length] = ',';
							}
							a.push( this.string(i), ':', v );
							b = true;
						}
					}
				}
				a[ a.length ] = '}';
				return a.join('');
			}
			return 'null';
		},
		// - types -

		m:{  // A character conversion map
			'\b': '\\b', '\t': '\\t',  '\n': '\\n', '\f': '\\f',
			'\r': '\\r', '"' : '\\"',  '\\': '\\\\'
		} // m
	};
}